import {
  Box,
  Card,
  CircularProgress,
  Container,
  Icon,
  IconButton,
  Tooltip,
} from "@mui/material";
import React, { useMemo, useState } from "react";
import Flx from "../../../components/layout/Flx";
import Htag from "../../../components/typography/Htag";
import Txt from "../../../components/typography/Txt";
import { sub } from "date-fns";
import { isNil } from "lodash";
import {
  CloseFullscreenOutlined,
  OpenInFullOutlined,
} from "@mui/icons-material";
import { grey } from "@mui/material/colors";

const PrimaryContentCard = ({
  children,
  title,
  subTitle,
  endContent,
  loading = false,
  expandedable = false,
  maxWidth,
  sx,
  cardSx,
  headerSx,
  containerSx,
  titleEndContent,
  bodySx,
  titleSx,
}) => {
  const [expanded, setExpanded] = useState(false);
  const rootStyles = useMemo(() => {
    return {
      py: 4,
      ...sx,
      ...containerSx,
    };
  }, [sx, containerSx]);

  const cardContent = (
    <CardPaper sx={cardSx}>
      {/* <Flx column gap={2} sx={{ p: 2 }}> */}
      <Header
        title={title}
        titleEndContent={titleEndContent}
        subTitle={subTitle}
        expanded={expanded}
        titleSx={titleSx}
        expandedable={expandedable}
        endContent={endContent}
        onExpandClick={() => setExpanded(!expanded)}
        sx={headerSx}
      />

      {loading ? (
        <Flx center>
          <CircularProgress size={24} sx={{ my: 8 }} />
        </Flx>
      ) : (
        <Box sx={bodySx}>{children}</Box>
      )}
      {/* </Flx> */}
    </CardPaper>
  );

  if (maxWidth) {
    return (
      <Container maxWidth={expanded ? false : maxWidth} sx={rootStyles}>
        {cardContent}
      </Container>
    );
  }
  return cardContent;
};

const CardPaper = ({ children, sx }) => {
  const rootStyles = useMemo(() => {
    return {
      overflow: "hidden",
      boxShadow:
        "rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.1) 0px 4px 6px -4px",
      mb: 4,
      p: 4,
      display: "flex",
      flexDirection: "column",
      ...sx,
    };
  }, [sx]);
  return <Card sx={rootStyles}>{children}</Card>;
};

const Header = ({
  title,
  subTitle,
  sx,
  titleSx,
  titleEndContent,
  endContent,
  expanded,
  expandedable,
  onExpandClick,
}) => {
  const rootStyles = useMemo(() => {
    return {
      mb: 2,

      ...sx,
    };
  }, [sx]);
  if (isNil(title)) return null;
  return (
    <Flx wrap gap={2} fw jb ac sx={rootStyles}>
      <Flx column gap={0.5}>
        <Flx ac g={1}>
          <Htag sx={titleSx}>{title}</Htag>
          {titleEndContent}
        </Flx>
        {subTitle && <Txt secondary>{subTitle}</Txt>}
      </Flx>
      <Flx ac>
        {!expandedable ? null : expanded ? (
          <Tooltip title="Collapse">
            <IconButton
              onClick={onExpandClick}
              sx={{ background: grey[200] }}
              size="small"
            >
              <CloseFullscreenOutlined className="thin" />
            </IconButton>
          </Tooltip>
        ) : (
          <Tooltip title="Expand">
            <IconButton onClick={onExpandClick} size="small">
              <OpenInFullOutlined className="thin" />
            </IconButton>
          </Tooltip>
        )}
        {endContent && <div>{endContent}</div>}
      </Flx>
    </Flx>
  );
};
export default PrimaryContentCard;
